/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L6_NInputs */

const en_mk_sec_pg_l6_n = /** @type {(inputs: Mk_Sec_Pg_L6_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The owner can do it themselves in Settings; the data goes with it rather than being hidden.`)
};

const id_mk_sec_pg_l6_n = /** @type {(inputs: Mk_Sec_Pg_L6_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilik bisa menghapus sendiri lewat Pengaturan; data ikut terhapus, bukan sekadar disembunyikan.`)
};

/**
* | output |
* | --- |
* | "The owner can do it themselves in Settings; the data goes with it rather than being hidden." |
*
* @param {Mk_Sec_Pg_L6_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l6_n = /** @type {((inputs?: Mk_Sec_Pg_L6_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L6_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l6_n(inputs)
	return en_mk_sec_pg_l6_n(inputs)
});